<script>
	import { getContext, createEventDispatcher } from 'svelte'
	import { fly, fade } from 'svelte/transition'
	import Dropzone from 'svelte-file-dropzone'
	import { styles } from '../scripts/styles.js'

	//the action to set (upload or alter)
	export let allowedImages = 100
	export let filesAccepted = ['images/jpeg', 'images/jpg', 'images/png']

	let dispatch = createEventDispatcher()

	const globals = getContext('globals')
	const buttonSmallColor = globals.adminButtonColor
	const buttonSmallBg = globals.adminButtonBg
	const buttonSmallBgHover = globals.adminButtonBgBgHover
	const fsXS = globals.fsXS
	const fsS = globals.fsS
	const colorMain = globals.adminColorMain
	const borderColor = globals.adminInputBorder
	const dropperBg = globals.adminInputBg

	//icon size
	let iconHeight = 50

	let files = []

	let dragText = 'or drag and drop it here'
	//responsive
	let windowWidth = window.innerWidth
	$: if (windowWidth < 569) {
		dragText = 'or drag them here'
		iconHeight = 25
	}

	function handleFilesSelect(e) {
		if (e.detail.acceptedFiles.length < 1) return
		const key = e.detail.acceptedFiles[0].name
		const value = e.detail.acceptedFiles[0]
		files = [...files, { [key]: value }]

		if (files.length > allowedImages) {
			handleRemoveEmpty(key)
			dispatch('upload', { error: 'true' })
			return
		}

		//create dropper row with image
		let dropper = document.getElementById('dropper')
		let reader = new FileReader()
		reader.readAsDataURL(value)
		reader.onload = () => {
			let image = new Image()
			image.src = reader.result
			image.onload = () => {
				let canvas = document.createElement('canvas')
				let ctx = canvas.getContext('2d')
				let prev = document.createElement('div')
				prev.style.display = 'flex'
				prev.style.fontSize = fsS
				prev.style.marginLeft = '15px'
				prev.style.marginBottom = '10px'
				prev.setAttribute('id', e.detail.acceptedFiles[0].name)
				canvas.height = iconHeight
				canvas.width = iconHeight
				ctx.drawImage(image, 0, 0, canvas.width, canvas.height)

				//create the remove link
				const rmv = document.createElement('div')
				rmv.innerText = 'remove'
				rmv.style.marginLeft = '15px'
				rmv.style.cursor = 'pointer'

				//add the remove action
				rmv.addEventListener('click', function () {
					handleRemoveFile(e.detail.acceptedFiles[0].name)
				})

				//append all to dom
				prev.appendChild(canvas)
				prev.appendChild(rmv)
				// dropper.appendChild(prev)
			}
		}

		dispatch('upload', { files: files })
	}

	function handleRemoveEmpty(f) {
		//remove object from files
		files = files.filter((element) => {
			return element.f === element[f]
		})
	}

	function handleRemoveFile(f) {
		//remove div from dropper
		const dropper = document.getElementById('dropper')
		const del = document.getElementById(f)
		dropper.removeChild(del)

		//remove object from files
		files = files.filter((element) => {
			return element.f === element[f]
		})

		dispatch('remove', { file: f })
	}
</script>

<main use:styles={{ colorMain }}>
	<div class="dropper" use:styles={{ dropperBg }}>
		<Dropzone on:drop={handleFilesSelect} accept={filesAccepted}>
			<button use:styles={{ buttonSmallColor, buttonSmallBg, buttonSmallBgHover, fsXS, colorMain }}>
				select file
			</button>

			<p use:styles={{ fsXS }}>{dragText}</p>
		</Dropzone>
	</div>

	<!-- <div id="dropper" in:fly={{ x: -200 }} use:styles={{ borderColor }} class="dropper_result" /> -->
</main>

<style>
	main {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: var(--colorMain);
		height: clamp(80px, 12vw, 180px);
		width: clamp(240px, 40vw, 600px);
	}
	button {
		color: var(--colorMain);
		background-color: var(--buttonSmallBg);
		font-size: var(--fsXS);
		cursor: pointer;
	}

	button:hover {
		background-color: var(--buttonSmallBgHover);
	}

	p {
		font-size: var(--fsXS);
		text-align: center;
		user-select: none;
	}

	.dropper {
		display: flex;
		width: 100%;
		background: var(--dropperBg);
	}

	/* .dropper_result {
		display: flex;
		flex-direction: column;
		border-left: 1px solid var(--borderColor);
		height: 100%;
		width: 30%;
		overflow-y: auto;
		margin-left: 10px;
	} */
</style>
